// lib/schemas/consultSchema.ts
import { z } from "zod";

export const consultSchema = z.object({
  // Step 2
  goal: z.enum(["home", "business", "recycle"]),

  // Step 3
  budget: z.enum(["100k-500k", "500k-1m", "1m-5m", "5m-20m", "not-sure"]),

  // Step 4
  country: z.string().min(1, "Country is required"),
  state: z.string().min(1, "State is required"),
  city: z.string().min(1, "City is required"),

  // Step 5
  name: z.string().min(1, "Full name is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().min(10, "Phone number is too short"),
  needs: z.string().optional(),
});

export type ConsultFormData = z.infer<typeof consultSchema>;